/**
 * @property {string} name
 * @property {RequestLogData} RequestLogData
 * @property {?number} responseStatus
 * @property {?object} responseBody
 * @property {string} stack
 * @property {boolean} isExpected
 * @property {boolean} isNonessential
 * @property {boolean} isFatal
 * @property {string} _responseBody
 */
export default class RequestError extends Error {
  /**
   * @param {RequestLogData} requestLogData
   * @param {?number} responseStatus
   * @param {?object} responseBody
   * @param {?string} stack
   * @param {?boolean} isExpected
   * @param {?boolean} isNonessential
   * @param {?boolean} isFatal
   * @param {?boolean} isProcessing
   */
  constructor({
    requestLogData,
    responseStatus = null,
    responseBody = null,
    stack = null,
    isExpected = false,
    isNonessential = false,
    isFatal = false,
    isProcessing = false,
  }) {
    const { request, response } = requestLogData;
    const message = (() => {
      if (isProcessing) {
        return `${request.method} ${request.url} call failed due to response processing.`;
      }
      if (response) {
        return `${request.method} ${request.url} call failed with status ${response.status}.`;
      }
      return `${request.method} ${request.url} call failed to fetch.`;
    })();

    super(message);

    this.responseStatus = responseStatus;
    this.responseBody = responseBody;

    if (stack) {
      this.stack = stack;
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, RequestError);
    } else {
      this.stack = null;
    }

    // Use `name` to identify instances instead of `instanceof` which might not work across separately
    // bundled packages.
    this.name = 'RequestError';

    this.requestLogData = requestLogData;
    this.isExpected = isExpected;
    this.isNonessential = isNonessential;
    this.isFatal = isFatal;
  }
}
